import React, { useContext, useState } from "react";
import { StoreContext } from "../context/StoreContext";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import GetAppIcon from "@mui/icons-material/GetApp";
import ExportExpiredBookigns from "./ExportExpiredBookings";
import ExportProvidersReviews from "./ExportProvidersReviews";
import ExportClientList from "./ExportClientList";
import ExportUsersList from "./ExportUsersList";
import ExportBookingList from "./ExportBookingList";
import ExportOrderList from "./ExportOrderList";

import { OUTLET_PAGE } from "../context/reducers";
import { useNavigate } from "react-router-dom";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Grid,
    Button,
    Link,
    ListItemButton
} from "@mui/material";
import ExportPayrollList from "./ExportPayrollList";
import { getUserFromCache } from "../user/UserCommon";
import { isMbxUserAdmin, isMbxUserManager } from "../atoms/atoms";
import { useAtom } from "jotai";

function ReportForm(props) {
    const navigate = useNavigate();
    const [isAdminLoggedIn] = useAtom(isMbxUserAdmin);
    const [isManagerLoggedIn] = useAtom(isMbxUserManager);

    const useStyles = makeStyles((theme) => ({
        root: {
            width: "100%",
            maxWidth: 360,
            backgroundColor: theme.palette.background.paper
        }
    }));

    const [featureDisabled, setShowFeatureDisabled] = useState(false);
    const [showExportUsers, setShowExportUsers] = useState(false);
    const [showExportOrders, setShowExportOrders] = useState(false);
    const [showExportBookings, setShowExportBookings] = useState(false);

    const classes = useStyles();
    const { actions } = useContext(StoreContext);

    let title = (
        <Typography
            id="MBReportsForm"
            className={classes.title}
            sx={{ fontSize: "24px", fontWeight: 400 }}
            variant="h4"
            noWrap
        >
            Reports
        </Typography>
    );

    let potentialSales = (
        <>
            <ListItemButton
                onClick={() => {
                    actions.setPage(OUTLET_PAGE);
                    navigate("/waitlist");
                }}
            >
                <ListItemIcon>
                    <GetAppIcon />
                </ListItemIcon>
                <ListItemText primary="Waitlist" />
            </ListItemButton>
            <Divider />
        </>
    );
    let billingCharges = (
        <>
            <ListItemButton
                onClick={() => {
                    actions.setPage(OUTLET_PAGE);
                    navigate("/billing-charges");
                }}
            >
                <ListItemIcon>
                    <GetAppIcon />
                </ListItemIcon>
                <ListItemText primary="Billing charges" />
            </ListItemButton>
            <Divider />
        </>
    );
    let addCharges = (
        <>
            <ListItemButton
                onClick={() => {
                    actions.setPage(OUTLET_PAGE);
                    navigate("/additional-charges");
                }}
            >
                <ListItemIcon>
                    <GetAppIcon />
                </ListItemIcon>
                <ListItemText primary="Additional charges" />
            </ListItemButton>
            <Divider />
        </>
    );

    let exportPayrollList = (
        <>
            <ExportPayrollList />
            <Divider />
        </>
    );

    let exportDeclinedBookings = (
        <>
            <ExportExpiredBookigns />
            <Divider />
        </>
    );

    let exportProviderRatings = (
        <>
            <ExportProvidersReviews />
            <Divider />
        </>
    );

    let exportClientList = (
        <>
            <ExportClientList />
            <Divider />
        </>
    );

    let exportUsersList = (
        <>
            <ListItemButton onClick={() => setShowExportUsers(true)}>
                <ListItemIcon>
                    <GetAppIcon />
                </ListItemIcon>
                <ListItemText primary="Users list" />
            </ListItemButton>
            <Divider />
        </>
    );
    let exportOrdersList = (
        <>
            <ListItemButton onClick={() => setShowExportOrders(true)}>
                <ListItemIcon>
                    <GetAppIcon />
                </ListItemIcon>
                <ListItemText primary="Orders list" />
            </ListItemButton>
            <Divider />
        </>
    );

    let exportBookingsList = (
        <>
            <ListItemButton onClick={() => setShowExportBookings(true)}>
                <ListItemIcon>
                    <GetAppIcon />
                </ListItemIcon>
                <ListItemText primary="Bookings list" />
            </ListItemButton>
            <Divider />
        </>
    );

    let exportAuditRecords = (
        <>
            <ListItemButton
                button
                onClick={() => {
                    actions.setPage(OUTLET_PAGE);
                    navigate("/audit-trail");
                }}
            >
                <ListItemIcon>
                    <GetAppIcon />
                </ListItemIcon>
                <ListItemText primary="Audit trail" />
            </ListItemButton>{" "}
        </>
    );

    let display, list;
    const managerOptions = [
        potentialSales,
        exportPayrollList,
        exportProviderRatings,
        exportClientList,
        exportOrdersList,
        exportBookingsList,
        exportUsersList
    ];
    const adminOptions = [
        ...managerOptions,
        billingCharges,
        addCharges,
        exportAuditRecords
    ];

    const options = isAdminLoggedIn
        ? adminOptions
        : isManagerLoggedIn
        ? managerOptions
        : [];
    if (getUserFromCache()?.company?.providerMustAcceptAppt)
        options.splice(4, 0, exportDeclinedBookings);
    list = (
        <List component="nav" aria-label="main mailbox folders">
            {options}
        </List>
    );
    display = (
        <>
            <div className={classes.root}>{list}</div>
            <Grid container justifyContent="center" alignItems="center" mb={4}>
                <Grid item>
                    <Typography variant="body1" sx={{ fontSize: 14 }}>
                        Can't find the data you're looking for? Just ask us at{" "}
                        <Link href="mailto:support@gomarketbox.com">
                            support@gomarketbox.com
                        </Link>
                        !
                    </Typography>
                </Grid>
            </Grid>
        </>
    );
    display = [title, display];

    if (featureDisabled) {
        return (
            <Dialog
                open={featureDisabled}
                fullWidth={true}
                aria-labelledby="show-client-dialog-title"
                aria-describedby="show-client-dialog-description"
            >
                <DialogTitle
                    id="show-client-dialog-title"
                    sx={{ fontSize: "24px", fontWeight: 400 }}
                >
                    This feature is currently disabled on your account
                </DialogTitle>
                <DialogContent dividers style={{ padding: 22 }}>
                    <DialogContentText id="show-client-dialog-description">
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <Typography variant="body1">
                                    To turn it on: Go to Company Settings{" "}
                                    {"\u2192"} Turn on 'Company Collects
                                    Payments'
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <Typography variant="body1">
                                    You will then need to connect your Stripe
                                    account to MarketBox
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={4} justifyContent="center">
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    onClick={() =>
                                        setShowFeatureDisabled(false)
                                    }
                                    color="primary"
                                >
                                    Okay
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }

    return (
        <>
            {showExportUsers && (
                <ExportUsersList
                    onExportComplete={() => setShowExportUsers(false)}
                />
            )}
            {showExportOrders && (
                <ExportOrderList
                    open={showExportOrders}
                    onClose={() => setShowExportOrders(false)}
                />
            )}
            {showExportBookings && (
                <ExportBookingList
                    open={showExportBookings}
                    onClose={() => setShowExportBookings(false)}
                />
            )}
            {display}
        </>
    );
}

export default ReportForm;
